
import { defineComponent } from "vue";
import "@/assets/scss/patient/profile.scss";
import axios from "axios";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "profile",
  data() {
    return {
      id: "",
      first_name: "",
      last_name: "",
      age: "",
      birthday: "",
      address: "",
      height: "",
      weight: "",
      bmi: "",
      blood_type: "",
      history: "",
      national_code: "",
      mobile: "",
      underlying_diseases: "",
      image_path: "",
      imagePreview: "",
      selectedImage: null as File | null,
      show: false,
      showEdit: true,
      isEditing: false,
      device_number: "",
      last_device_calibration_at: "",
    };
  },
  methods: {
    fetchProfile() {
      axios
        .get("/patient")
        .then((res) => {
          if (res.data.id) {
            this.id = res.data.id;
            this.first_name = res.data.first_name;
            this.last_name = res.data.last_name;
            this.birthday = res.data.birthday;
            this.age = res.data.age;
            this.address = res.data.address;
            this.height = res.data.height;
            this.weight = res.data.weight;
            this.national_code = res.data.national_code;
            this.mobile = res.data.mobile;
            this.blood_type = res.data.blood_type;
            this.underlying_diseases = res.data.underlying_diseases;
            this.image_path = res.data.image;
            this.device_number =
              res.data.device_number && res.data.device_number !== "null"
                ? res.data.device_number
                : "";

            this.last_device_calibration_at =
              res.data.last_device_calibration_at &&
                res.data.last_device_calibration_at !== "null"
                ? res.data.last_device_calibration_at
                : "";

          }
        })
        .catch((error) => {
          console.log(error.status);
        });
    },
    triggerFileInput() {
      if (this.isEditing) {
        (this.$refs.fileInput as HTMLInputElement).click();
      }
    },
    onImageSelect(event: Event) {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files[0]) {
        this.selectedImage = target.files[0];
        this.imagePreview = URL.createObjectURL(target.files[0]);
      }
    },
    save() {
      const formData = new FormData();
      const fields: Record<string, string> = {
        first_name: this.first_name,
        last_name: this.last_name,
        birthday: this.birthday,
        age: this.age,
        address: this.address,
        height: this.height,
        weight: this.weight,
        blood_type: this.blood_type,
        national_code: this.national_code,
        mobile: this.mobile,
        underlying_diseases: this.underlying_diseases,
        device_number: this.device_number,
        last_device_calibration_at: this.last_device_calibration_at,
      };
      for (const [key, value] of Object.entries(fields)) {
        if (value !== "" && value !== "null") {
          formData.append(key, value);
        }
      }
      if (this.selectedImage) {
        formData.append("image", this.selectedImage);
      }
      formData.append("_method", "PUT");
      axios
        .post(`/patient/${this.id}`, formData)
        .then(() => {
          this.showEdit = true;
          this.show = false;
          this.isEditing = false;
          this.selectedImage = null;
          this.imagePreview = "";
          this.fetchProfile();
          window.alert("پروفایل با موفقیت ویرایش شد");
        })
        .catch((error) => {
          console.log(error);
          window.alert("خطا در ویرایش پروفایل");
        });
    },
    close() {
      this.showEdit = true;
      this.show = false;
      this.isEditing = false;
      this.imagePreview = "";
      this.selectedImage = null;
      this.fetchProfile();
    },
    edit() {
      this.show = true;
      this.showEdit = false;
      this.isEditing = true;
    },
  },
  mounted() {
    this.fetchProfile();
  },
});
